import { createDataModuleActions } from '@perpay-web/data-module/createDataModuleActions';

const submitPerpayPlusSoloApplicationActions = createDataModuleActions(
    'SUBMIT_PERPAY_PLUS_SOLO_APPLICATION',
);
export const submitPerpayPlusSoloApplication =
    submitPerpayPlusSoloApplicationActions.dataRequest;
export const submitPerpayPlusSoloApplicationSuccess =
    submitPerpayPlusSoloApplicationActions.dataSuccess;
export const submitPerpayPlusSoloApplicationError =
    submitPerpayPlusSoloApplicationActions.dataError;
export const submitPerpayPlusSoloApplicationReset =
    submitPerpayPlusSoloApplicationActions.dataReset;

const createPerpayPlusSoloFeatureEnrollmentActions = createDataModuleActions(
    'CREATE_PERPAY_PLUS_SOLO_FEATURE_ENROLLMENT',
);
export const createPerpayPlusSoloFeatureEnrollment =
    createPerpayPlusSoloFeatureEnrollmentActions.dataRequest;
export const createPerpayPlusSoloFeatureEnrollmentSuccess =
    createPerpayPlusSoloFeatureEnrollmentActions.dataSuccess;
export const createPerpayPlusSoloFeatureEnrollmentError =
    createPerpayPlusSoloFeatureEnrollmentActions.dataError;
export const createPerpayPlusSoloFeatureEnrollmentReset =
    createPerpayPlusSoloFeatureEnrollmentActions.dataReset;

const createPerpayPlusSoloEnrollmentInMarketplacePHOActions =
    createDataModuleActions(
        'CREATE_PERPAY_PLUS_SOLO_ENROLLMENT_IN_MARKETPLACE_PHO',
    );
export const createPerpayPlusSoloEnrollmentInMarketplacePHO =
    createPerpayPlusSoloEnrollmentInMarketplacePHOActions.dataRequest;
export const createPerpayPlusSoloEnrollmentInMarketplacePHOSuccess =
    createPerpayPlusSoloEnrollmentInMarketplacePHOActions.dataSuccess;
export const createPerpayPlusSoloEnrollmentInMarketplacePHOError =
    createPerpayPlusSoloEnrollmentInMarketplacePHOActions.dataError;
